import { markdownExtensions } from './extensions';
import {
  ErrorImporting,
  IRemarkableBlockExtension,
  IRemarkableInlineExtension,
  RemarkableExtension,
} from './types';

function isInlineExtension(
  ext: RemarkableExtension,
): ext is IRemarkableInlineExtension {
  return ext.parser.length === 2;
}

function isBlockExtension(
  ext: RemarkableExtension,
): ext is IRemarkableBlockExtension {
  return ext.parser.length === 4;
}

export async function getRemarkable(extensions?: RemarkableExtension[]) {
  const md = new ((await import('remarkable'))?.Remarkable ?? ErrorImporting)({
    html: true,
  });
  if (md instanceof ErrorImporting)
    throw new Error('Could not import remarkable, cannot continue');

  md.block.ruler.disable(['table']);

  [...(extensions ?? []), ...markdownExtensions].forEach((ext) => {
    if (isInlineExtension(ext))
      md.inline.ruler.before('text', ext.name, ext.parser, {});
    else if (isBlockExtension(ext))
      md.block.ruler.before('code', ext.name, ext.parser, {});
    md.renderer.rules[ext.name] = ext.replacer(md);
  });

  return md;
}
